import React, { useState, useEffect } from 'react';
import  { useNavigate, useLocation } from 'react-router-dom'

import HeaderComponent from '../components/Header.js'
import FooterComponent from '../components/Footer'

import iconSuccess from '../images/confirmation/ic_success.svg'



function ConfirmationPage() {

  const navigate = useNavigate();
  const { state } = useLocation()

  const [ policyNumber, setPolicyNumber ] = useState("")
  const [ pets, setPets ] = useState([])

  function gotoHome(){
    navigate(
      "/",
      {
        replace: true 
      }
    )
  }


  useEffect(() => {
    window.scrollTo(0, 0)
    setPolicyNumber( state.policy_number )
    callGetPolicyApi( state.policy_number )
  }, [])


  function callGetPolicyApi( policy ){
    const requestOptions = {
      method: 'POST',
      body: JSON.stringify(
        { 
          policy_no: policy
        }
      )
    };
  
    fetch('https://petregister.innovation.thaivivat.co.th/api/v1/service/api/getPets.php', requestOptions)
    .then(response => response.json())
    .then(data => validateGetPolicyApi(data), (error) => {
      if (error) {
        // handle error here
      }
    });
    
  } 

  function validateGetPolicyApi( data ){
    if(data.data !== undefined ){
      if(data.data.info !== null){
        setPets(data.data.info)
      }
    }
  }

  function getDateThai( data ){
    let dateArray = data.split("-")
    return dateArray[2]+"/"+dateArray[1]+"/"+(parseInt(dateArray[0])+543)
  }

  function getDOBFormat( data ){
    if(data.dob_type.id === "1"){
      return `${data.dob_type.description} - ${ getDateThai(data.pet_dob) }`
    }
    else{
      return `${data.dob_type.description} - ${ data.pet_age } ${ data.pet_date_scale.description}`
    }
  }

  return (
  <div className="w-full flex flex-wrap bg-grey-200 font-prompt">
    <HeaderComponent></HeaderComponent>
    <div className='flex flex-wrap w-full  '>
    


      <div className='flex flex-wrap w-full  pl-4 md:pl-24 pr-4 md:pr-24 mt-16 justify-center'>
          <img src={iconSuccess} alt="" />
          <label className='flex text-xl md:text-2xl w-full mt-3 font-bold  text-black text-center justify-center'>ระบบได้รับข้อมูลสัตว์เลี้ยงของท่านแล้ว</label>
      </div>

      <div className='flex flex-wrap w-full'>
          <div className='flex flex-wrap w-full lg:w-1092 lg:mx-auto'> 
            <div className='flex flex-wrap w-full pl-4 md:pl-24 pr-4 md:pr-24  lg:pr-0 lg:pl-0  mt-8 md:mt-16 justify-center'>
                <div className='w-full border border-grey-300  rounded-md p-3 lg:p-4 bg-white'>
                  <label>เลขที่กรมธรรม์: { policyNumber }</label>
                </div>
            </div>
        </div>
      </div>


      {
        (pets).map(function(data, index){
          return      <div className='flex flex-wrap w-full'>
                        <div className='flex flex-wrap w-full lg:w-1092 lg:mx-auto'> 
          
                <div className='flex flex-wrap w-full pl-4 md:pl-24 pr-4 md:pr-24   lg:pr-0 lg:pl-0 mt-4 md:mt-6 justify-center '>
                      <div className='flex flex-wrap w-full border border-grey-300  rounded-md p-3 lg:p-4 bg-white'>
                        <div className='flex w-full'>
                            <div className='flex-none'>
                              <label className='w-full font-bold text-green-500 text-md'>ข้อมูลสัตว์เลี้ยง ตัวที่ { (index + 1) }</label>
                            </div>
                        </div>
                        

                        <label className='w-full md:w-2/6 text-grey-600 mt-4  text-sm'>ประเภทสัตว์เลี้ยง</label>
                        <label className='w-full md:w-4/6 font-medium md:text-base md:leading-5 text-black  mt-1 md:mt-4 text-sm'>{ data.pet_type.description }</label>

                        <label className='w-full md:w-2/6 text-grey-600 mt-4  text-sm'>เพศ</label>
                        <label className='w-full md:w-4/6 font-medium md:text-base md:leading-5 text-black    mt-1 md:mt-4  text-sm'>{ data.pet_gender.description }</label>

                        <label className='w-full md:w-2/6 text-grey-600 mt-4  text-sm'>สายพันธุ์</label>
                        <label className='w-full md:w-4/6 font-medium md:text-base md:leading-5 text-black    mt-1 md:mt-4  text-sm'>{ data.pet_specie }</label>

                        <label className='w-full md:w-2/6 text-grey-600 mt-4  text-sm'>ชื่อสัตว์เลี้ยง</label>
                        <label className='w-full md:w-4/6 font-medium md:text-base md:leading-5 text-black    mt-1 md:mt-4 text-sm'>{ data.pet_name }</label>

                        <label className='w-full md:w-2/6 text-grey-600 mt-4  text-sm'>อายุสัตว์เลี้ยง</label>
                        <label className='w-full md:w-4/6 font-medium md:text-base md:leading-5 text-black    mt-1 md:mt-4  text-sm'>{ getDOBFormat(data) }</label>

                        <label className='w-full md:w-2/6 text-grey-600 mt-4  text-sm'>ใบรับรองไมโครชิพ</label>
                        <label className='w-full md:w-4/6 font-medium md:text-base md:leading-5 text-black    mt-1 md:mt-4  text-sm'>{ data.is_microchip.description }{ (data.is_microchip.id === "0")? "" : ` - ${data.microchip_no}` }</label>

                        <label className='w-full md:w-2/6 text-grey-600 mt-4  text-sm'>ใบรับรองเพ็ดดีกรี</label>
                        <label className='w-full md:w-4/6 font-medium md:text-base md:leading-5 text-black    mt-1 md:mt-4  text-sm'>{ data.is_pet_degree.description }{ (data.is_pet_degree.id === "0")? "" : ` - ${data.pet_degree_no} , ${data.pet_degree_create_by}` }</label>

                        <label className='w-full md:w-2/6 text-grey-600 mt-4  text-sm'>โรงพยาบาลสัตว์ที่ใช้บริการเป็นประจำ (ถ้ามี)</label>
                        <label className='w-full md:w-4/6 font-medium md:text-base md:leading-5 text-black    mt-1 md:mt-4  text-sm'>{ data.pet_hospital }</label>

                        <label className='w-full md:w-2/6 text-grey-600 mt-4  text-sm'>เบอร์โทรศัพท์เจ้าของสัตว์เลี้ยง</label>
                        <label className='w-full md:w-4/6 font-medium md:text-base md:leading-5 text-black    mt-1 md:mt-4  text-sm'>{ data.owner_tel }</label>

                        <label className='w-full text-grey-600 mt-4  text-sm'>รูปถ่ายสัตว์เลี้ยงหน้าตรง</label>
                        <div className='w-full md:w-2/6 mt-1 md:mt-4'>
                          <img src={ data.image_front }  alt="" className='rounded-lg' />
                        </div>

                        <label className='w-full  text-grey-600 mt-4  text-sm'>รูปถ่ายสัตว์เลี้ยงเต็มตัว</label>
                        <div className='w-full md:w-2/6 mt-1 md:mt-4'>
                          <img src={ data.image_full_body } alt=""  className='rounded-lg' />
                        </div>

                      </div>
                  </div>
            </div>
          </div>      
        })
      }
      

    







      <div className='flex flex-wrap w-full  pl-4 md:pl-24 pr-4 md:pr-24 lg:px-24 mt-6 md:mt-6 mb-20 justify-center'>
        <button onClick={gotoHome} className='w-full lg:w-96 h-[48px] text-base bg-green-500  rounded-lg text-white font-medium leading-6' >กลับสู่หน้าหลัก</button>
      </div>


    </div>
    <FooterComponent></FooterComponent>
  </div>
  )
}

export default ConfirmationPage;